export default __webpack_public_path__ + "info-space-to-preview@2x.png";